interface ErrorTranslations {
  [key: string]: string;
}
const errorMessages: ErrorTranslations = {
  ONLY_ONE_ACTIVE_QUESTION_TYPE_5: 'タイプ5の有効な質問は1つのみ設定できます。',
  QUESTION_SET_NOT_FOUND: 'アンケートセットが見つかりません。',
  MUST_HAVE_ONE_ACTIVE: '有効なアンケートセットが少なくとも1つ必要です。',
};
export const errorCode = (errorCode: string | undefined | null, defaultMessage: string): string => {
  if (errorCode && errorMessages[errorCode]) {
    return errorMessages[errorCode];
  }
  if (typeof errorCode === 'string' && errorCode.length > 30) {
    return errorCode;
  }
  return defaultMessage;
};
